import React from 'react';

import { Link } from 'react-router-dom';

import CourseLogo from '../common/CourseLogo';

interface MemberCourseCellProps {
  courseId?: string;
  name?: string;
  // "Western Cape, South Africa", or the free-text address.
  subtitle?: string;
  logoFileId?: string;
  closed?: boolean;
  // Greyed, for a row switched off on this visit (courses played).
  muted?: boolean;
  // No logo on a phone, for a table with one more column to fit (the courses played ranking's
  // Score). Measured at 375px, the logo was what pushed the Played switch off the edge, and the
  // name is worth more than the logo there. From sm up it is the same as every other table.
  compact?: boolean;
}

// The course cell of the member's own tables (courses played, home courses, bucket list). Unlike
// the admin-era CourseCell it keeps the logo on a phone, because these tables are the phone's
// lists now (the profile's golf lists), and a name links to the course's own page.
//
// Capped so the truncate has a width to work to. A table cell has none of its own, so one long
// legacy address stretched the column and pushed the last column off the side of the card.
const MemberCourseCell: React.FC<MemberCourseCellProps> = ({
  courseId,
  name,
  subtitle,
  logoFileId,
  closed,
  muted = false,
  compact = false,
}) => (
  <div
    className={`flex items-center gap-3 sm:max-w-[18rem] xl:max-w-md ${
      compact ? 'max-w-[8rem]' : 'max-w-[11rem]'
    } ${muted ? 'opacity-50' : ''}`}
  >
    <CourseLogo
      logoFileId={logoFileId}
      name={name ?? ''}
      closed={closed}
      className={`h-10 w-10 shrink-0 rounded ${compact ? 'hidden sm:block' : ''}`}
    />
    <div className="min-w-0">
      {courseId != null ? (
        <Link
          to={`/courses/${courseId}`}
          className="block truncate text-sm font-medium text-ink underline-offset-2 hover:text-primary-deep hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary dark:text-white dark:hover:text-primary"
        >
          {name || 'Unknown course'}
        </Link>
      ) : (
        <p className="truncate text-sm font-medium text-ink dark:text-white">
          {name || 'Unknown course'}
        </p>
      )}
      {subtitle && (
        <p className="truncate text-xs text-ink-muted dark:text-white/50">
          {subtitle}
        </p>
      )}
    </div>
  </div>
);

export default MemberCourseCell;
